import { render, staticRenderFns } from "./tabs-head.vue?vue&type=template&id=1e711b88&scoped=true&"
import script from "./tabs-head.vue?vue&type=script&lang=js&"
export * from "./tabs-head.vue?vue&type=script&lang=js&"
import style0 from "./tabs-head.vue?vue&type=style&index=0&id=1e711b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e711b88",
  null
  
)

component.options.__file = "tabs-head.vue"
export default component.exports